import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: ToastState = {
  visible: false,
  message: ''
};

export interface ToastState {
  visible: boolean;
  message: string;
}

export const slice = createSlice({
  name: 'toast',
  initialState: initialState,
  reducers: {
    show: (state, action: PayloadAction<string>) => {
      state.visible = true;
      state.message = action.payload;
    },
    hide: (state) => {
      state.visible = false;
    }
  }
});

export default slice.reducer;
export const { show, hide } = slice.actions;
